import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <div className="flex items-center justify-center mb-6" data-id="element-101">
          <AlertTriangle className="w-12 h-12 text-brand-orange" data-id="element-102" />
        </div>
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-10 text-center uppercase" data-id="element-103">
          Vivir en USA es una <span className="text-brand-orange" data-id="element-104">trampa</span>{' '}
          para tu cintura
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed bg-dark-surface p-8 md:p-10 rounded-xl border border-gray-800 shadow-2xl" data-id="element-105">
          <p data-id="element-106">
            Entre el estrés del trabajo, las harinas procesadas escondidas en
            todo lo que comprás y el cortisol por las nubes, tu cuerpo entró en{' '}
            <strong data-id="element-107">"Modo Ahorro"</strong>.
          </p>
          <p data-id="element-108">
            Tu cerebro cree que estás en peligro y le ordena a tus hormonas que
            guarden cada caloría directamente en tu abdomen para "protegerte".
            Por eso, por más que comas menos, la panza sigue ahí, firme y
            pesada.
          </p>
          <p className="text-white font-semibold" data-id="element-109">
            Estás atrapado en un ciclo de inflamación sistémica que te roba la
            energía y te hace ver 10 años más viejo.
          </p>
        </div>
      </div>
    </section>;
}